import React, { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import ParallaxHero from '../ui/ParallaxHero';

interface ServiceHeaderProps {
  title: string;
  description: string;
  icon: ReactNode;
  color: string;
  imageUrl: string;
}

const ServiceHeader = ({ title, description, icon, color, imageUrl }: ServiceHeaderProps) => {
  return (
    <ParallaxHero 
      imageUrl={imageUrl}
      overlayColor={`${color}99`}
      height="50vh"
    >
      <div className="max-w-7xl mt-10 mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center">
        <Link 
          to="/" 
          className="inline-flex items-center text-white hover:text-gray-200 mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Link>
        
        <div className="flex items-center space-x-4 mb-6">
          <div 
            className="w-16 h-16 rounded-2xl flex items-center justify-center bg-white/10 backdrop-blur-sm"
          >
            {icon}
          </div>
          <h1 className="text-4xl font-bold text-white">
            {title}
          </h1>
        </div>
        
        <p className="text-xl text-white/90 max-w-3xl">
          {description}
        </p>
      </div>
    </ParallaxHero>
  );
};

export default ServiceHeader;